import { render } from "./VZHideIcon.vue?vue&type=template&id=1d5aa5e3&ts=true"
import script from "./VZHideIcon.vue?vue&type=script&lang=ts"
export * from "./VZHideIcon.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__